import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '../config';
import {
  addDevice,
  deleteDevice,
  getDeviceDetails,
  getDevices,
} from './methods';

const useGetDevicesQuery = () => {
  const { isPending, isSuccess, isError, data } = useQuery({
    queryFn: getDevices,
    queryKey: [queryKeys.deviceKey],
    refetchOnMount: 'always',
  });

  return { data, isError, isPending, isSuccess };
};

const useGetDeviceDetailsQuery = (deviceId: number) => {
  const { isPending, isSuccess, isError, data } = useQuery({
    enabled: !!deviceId,
    queryFn: () => getDeviceDetails(deviceId),
    queryKey: [queryKeys.deviceKey, deviceId],
  });

  return { data, isError, isPending, isSuccess };
};

const useAddDeviceMutation = () => {
  const queryClient = useQueryClient();

  const {
    isPending,
    isSuccess,
    isError,
    mutateAsync: addDeviceMutation,
  } = useMutation({
    mutationFn: addDevice,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.deviceKey] });
    },
  });

  return { addDeviceMutation, isError, isPending, isSuccess };
};

const useDeleteDeviceMutation = () => {
  const queryClient = useQueryClient();

  const {
    isPending,
    isSuccess,
    isError,
    mutateAsync: deleteDeviceMutation,
  } = useMutation({
    mutationFn: deleteDevice,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.deviceKey] });
    },
  });

  return { deleteDeviceMutation, isError, isPending, isSuccess };
};

export {
  useAddDeviceMutation,
  useDeleteDeviceMutation,
  useGetDeviceDetailsQuery,
  useGetDevicesQuery,
};
